<script setup lang="ts">
import { cn } from '../lib/utils';
import HorizontalLine from './HorizontalLine.vue';
const props = defineProps<{
  text: string
  color?: string
  class?: string
}>()
</script>
<template>
  <div :class="cn('flex flex-col justify-start items-start gap-1 text-xl', props.class)">
    <div class="flex items-center">
      <slot name="icon" />

      <h2 class="flex gap-4 font-bold">
        {{ text }}
      </h2>
      <slot />
    </div>
    <HorizontalLine :style="{ borderColor: color }" class="w-full" />
  </div>
</template>
